export default "__VITE_ASSET__CjYwXV1e__"